import { HttpFilter } from "sol-request-angular/dist/comunicacao";
import { Equal } from "sol-request-angular/dist/comunicacao/filter/Equal";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";

export class AitTaxiSearch {

    tpConcessao: number;
    nmAgente: string;
    cdAgente: number;
    cdPessoa: number;
    nrAit: string;
    stAit: number;
    tpAit: number;
    limit: number;
    page: number;

    constructor(data: {
        tpConcessao?: number,
        stAit?: number,
        nrAit?: string,
        nmAgente?: string,
        cdAgente?: number,
        cdPessoa?: number,
        tpAit?: number,
        limit?: number,
        page?: number
    },

    ) {
        this.tpConcessao = data && data.tpConcessao;
        this.nrAit = data && data.nrAit;
        this.nmAgente = data && data.nmAgente;
        this.cdAgente = data && data.cdAgente;
        this.cdPessoa = data && data.cdPessoa;
        this.stAit = data && data.stAit;
        this.tpAit = data && data.tpAit;
        this.limit = data && data.limit;
        this.page = data && data.page;
    }


    getFilters(): IFilter {
        let filtros: IFilter = new HttpFilter([]);
        
        if (this.nrAit)
            filtros.addFilter(new Equal('nrAit', this.nrAit));
 
        if (this.cdAgente)
            filtros.addFilter(new Equal('cdAgente', this.cdAgente));
        
        if (this.cdPessoa)
            filtros.addFilter(new Equal('cdPessoa', this.cdPessoa));

        if (this.nmAgente)
            filtros.addFilter(new Equal('nmAgente', this.nmAgente));

        if (this.stAit >= 0 && this.stAit != null)
            filtros.addFilter(new Equal('stAit', this.stAit));
        
        if (this.tpConcessao >= 0 && this.tpConcessao != null)
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));

        if (this.tpAit >= 0 && this.tpAit != null)
            filtros.addFilter(new Equal('tpAit', this.tpAit));

        if (this.limit) 
            filtros.addFilter(new Equal('limit', this.limit));

        if (this.page) 
            filtros.addFilter(new Equal('page', this.page));
            
        return filtros;
    }
}
